import type {
  GetBadgeDataListResponse,
  GetBadgeMissionResponse,
  GetDailyMissionResponse,
  MissionCountResponse,
} from "src/service/MissionApi/type";
import { serverApi } from "src/service/serverApi";

export const missionApi = serverApi.injectEndpoints({
  endpoints: (builder) => {
    return {
      getBadgeList: builder.query<GetBadgeDataListResponse, void>({
        providesTags: ["Missions"],
        query: () => {
          return { method: "get", url: `missions/badges` };
        },
      }),
      getDailyMissionList: builder.query<GetDailyMissionResponse, void>({
        providesTags: ["Missions"],
        query: () => {
          return { method: "get", url: `missions/daily_missions` };
        },
      }),
      getMissionList: builder.query<GetBadgeMissionResponse, void>({
        providesTags: ["Missions"],
        query: () => {
          return { method: "get", url: `missions/badge_missions` };
        },
      }),
      postMissionCount: builder.mutation<
        MissionCountResponse,
        { actionId: string }
      >({
        invalidatesTags: ["Missions", "Points"],
        query: (body) => {
          return { body: body, method: "post", url: `missions/count` };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useGetBadgeListQuery,
  useGetDailyMissionListQuery,
  useGetMissionListQuery,
  usePostMissionCountMutation,
} = missionApi;
